import "./HeaderHiragana.css";

const HeaderHiragana = () => {
  return (
    <div className="headerHiragana">
      <a href="#gojuon">Gojūon</a>
      <a href="#dakuten">Dakuten & Handakuten</a>
      <a href="#yoon">Yōon</a>{" "}
    </div>
  );
};

export default HeaderHiragana;
